import React from 'react';
import Section from '../Section/Section';
import Button from '../Button/Button';

const GlobalCallout: React.FC = () => {
  return (
    <Section theme="" bgName="lines" className="section-call-to-action">
      <h2 className="action-on-view action-fade-in">
        Let’s move your business forward.
      </h2>
      <p className="action-on-view action-fade-in">
        Learn how our solutions can empower your team and transform your
        operations.
      </p>
      <Button
        className="action-on-view action-fade-in button-size-large"
        url="/contact-us"
        label="Contact us today"
      />
    </Section>
  );
};

export default GlobalCallout;
